import React from "react";
import { AuthShowcaseSlider, ForgotPasswordForm } from "../register/individual/components";

const ForgotPassword = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-10 gap-6 items-stretch mt-4 xl:px-12 2xl:px-20 max-w-[1440px] mx-auto w-full">
      {/* Left Column: Swappable Form Card */}
      <div className="lg:col-span-4 w-full h-full flex flex-col">
        <div className="bg-white border border-gray-100 rounded-[2rem] p-6 sm:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] h-full flex flex-col justify-start">
          <ForgotPasswordForm />
        </div>
      </div>

      {/* Right Column: Shared Showcase Slider (Image 2) */}
      <AuthShowcaseSlider />
    </div>
  );
};

export default ForgotPassword;
